import { useEffect, useMemo, useState, useRef, SetStateAction } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
  type MRT_TableOptions,
} from 'material-react-table';
import {
  Chip,
  Pagination,
  Typography,
  TextField,
  Button,
  Box,
  InputAdornment,
  useMediaQuery,
  Menu,
  MenuItem,
  PaginationItem,
  Checkbox,
  Select,
} from '@mui/material';
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg';
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg';
import Custom from 'packages/novous_web/src/assets/icons/CustomBlue.svg';
import emailReportIcon from 'packages/novous_web/src/assets/icons/EmailReport.svg';
import downloadWhiteIcon from 'packages/novous_web/src/assets/icons/downloadWhiteIcon.svg';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import { useSidebar } from 'packages/novous_web/src/context/SideBarContext';
import arrow from 'packages/novous_web/src/assets/icons/Arrow.svg';
import calendar from 'packages/novous_web/src/assets/icons/calendar.svg';
import DateRangeFilter from '../../../../common/components/DateRange';
import add from 'packages/novous_web/src/assets/icons/plusBlue.svg';
import dayjs from 'dayjs';
import { ArrowBack } from '@mui/icons-material';
import { useNavigation } from 'react-router-dom';
import CustomiseTableModal from 'packages/novous_web/src/common/components/CustomiseTable';
import EmailModal from 'packages/novous_web/src/common/components/EmailData';
import DownloadData from 'packages/novous_web/src/common/components/DownloadData';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import useApiError from 'packages/novous_web/src/api/useApiError';
import CustomDropDownInput from 'packages/novous_web/src/common/components/customDropDownInput';
import DateFieldCalendar from 'packages/novous_web/src/common/components/DateFieldCalender';
import CustomConfirmationModal from 'packages/novous_web/src/common/components/CustomConfirmationModal';
import NotAuthorized from '../../../NotAuthorized';
// Define the shape of your data
interface DeviceLogs {
  deviceId: string;
  logFileName: string;
  fileStatus: string;
  fileDate: string;
  customerCrn: string;
}

const data: DeviceLogs[] = [];

type ColumnObjType = {
  [key: string | number]: {
    name: string;
    status: boolean;
  };
};

interface EmailApiResponse {
  data: string;
  error: string;
  message: string;
  status: number;
}

export default function DeviceLogs() {
  const [selectedRows, setSelectedRows] = useState<Record<string, boolean>>({});
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [alertType, setAlertType] = useState<'error' | 'success' | 'warning' | 'info'>('error');
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const location = useLocation();
  const vehicleData = location.state || {};
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const {
    data: downloadDeviceLogsData,
    error: downloadDeviceLogsError,
    errorStatus: downloadDeviceLogsErrorStatus,
    loading: downloadDeviceLogsLoading,
    fetchData: fetchDownloadDeviceLogsData,
  } = useApiError<any>(`${API_ENDPOINTS.users.DEVICE_LOGS_DOWNLOAD}`, 'POST', 'json');

  const {
    data: deleteCerificateDeviceLogsData,
    error: deleteCerificateDeviceLogsError,
    errorStatus: deleteCerificateDeviceLogsErrorStatus,
    loading: deleteCerificateDeviceLogsLoading,
    fetchData: fetchDeleteCerificateDeviceLogsData,
  } = useApiError<any>(`${API_ENDPOINTS.users.DEVICE_CERTIFICATE_DELETE}`, 'POST');

  const {
    data: deleteDataDeviceLogsData,
    error: deleteDataDeviceLogsError,
    errorStatus: deleteDataDeviceLogsErrorStatus,
    loading: deleteDataDeviceLogsLoading,
    fetchData: fetchDeleteDataDeviceLogsData,
  } = useApiError<any>(`${API_ENDPOINTS.users.DEVICE_DATA_DELETE}`, 'POST');

  const navigate = useNavigate();
  const dateRangeArr = ['Today', 'Yesterday', '7 Days', '15 Days', '30 Days', 'Custom Range'];

  const [selectedDuration, setSelectedDuration] = useState(dateRangeArr[0]);
  const [calendarAnchorEl, setCalendarAnchorEl] = useState<null | HTMLElement>(null);
  const [mapData, setMapData] = useState([]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const insightsRef = useRef<HTMLDivElement>(null);
  const [insightsWidth, setInsightsWidth] = useState<number | null>(null);
  const [startDate, setStartDate] = useState('');
  const { isSideBarOpen } = useSidebar();
  const [endDate, setEndDate] = useState('');
  const paginatedArr = useRef<(string | null)[]>([null]);
  const [isBulkDeleteModalOpen, setIsBulkDeleteModalOpen] = useState(false);

  const [columnObj, setColumnObj] = useState<ColumnObjType>({
    deviceId: { name: 'Device ID', status: true },
    logFileName: { name: 'File Name', status: true },
    fileStatus: { name: 'File Status', status: true },
    fileDate: { name: 'File Date', status: true },
    customerCrn: { name: 'Customer Crn', status: true },
    actions: { name: 'Actions', status: true },
  });

  const handleReset = () => {
    console.log('Reset clicked!');
  };

  // Function to get the date range based on selected duration
  const getDateRange = (range: string) => {
    const today = dayjs();
    let startDate, endDate;

    switch (range) {
      case 'Today':
        startDate = today.format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case 'Yesterday':
        startDate = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
        endDate = startDate;
        break;
      case '7 Days':
        startDate = dayjs().subtract(6, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case '15 Days':
        startDate = dayjs().subtract(14, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case '30 Days':
        startDate = dayjs().subtract(29, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      default:
        startDate = '';
        endDate = '';
    }
    return { startDate, endDate };
  };

  let { startDate: startDateC, endDate: endDateC } = getDateRange(selectedDuration);

  useEffect(() => {
    if (insightsRef.current) {
      setInsightsWidth(insightsRef.current.offsetWidth);
    }
  }, [isSideBarOpen]);

  useEffect(() => {
    if (startDateC !== '' && endDateC !== '') {
    }
  }, [startDateC, endDateC]);

  if (startDate !== '' && endDate !== '') {
    startDateC = startDate;
    endDateC = endDate;
  } else if (startDate === '' && endDate === '') {
    ({ startDate: startDateC, endDate: endDateC } = getDateRange(selectedDuration));
  }

  useEffect(() => {
    const { startDate: newStartDate, endDate: newEndDate } = getDateRange(selectedDuration);
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  }, [selectedDuration]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setCalendarAnchorEl(event.currentTarget);
  };

  const handleCalendarClose = () => {
    setShowDatePicker(false);
    setStartDate('');
    setEndDate('');
    setSelectedDuration(dateRangeArr[0]);
    setCalendarAnchorEl(null);
  };

  const handleLoseFocus = () => {
    console.log('Focus lost');
  };

  const handleClose = (value?: string) => {
    if (value) {
      setSelectedDuration(value);
      setShowDatePicker(value === 'Custom Range');
      const { startDate: newStartDate, endDate: newEndDate } = getDateRange(value);
      setStartDate(newStartDate);
      setEndDate(newEndDate);
    }
    setAnchorEl(null);
  };

  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isSmallScreen = useMediaQuery('(max-width:850px)');
  const pageSize = 5;
  const { user } = useAuth();

  interface DeviceLogsResponse {
    data: {
      deviceLogsList: DeviceLogs[];
      lastEvaluatedKey: string | null;
    };
  }

  const {
    data: DeviceLogsData,
    error: DeviceLogsError,
    errorStatus: DeviceLogsErrorStatus,
    loading: DeviceLogsLoading,
    fetchData: DeviceLogsRequestData,
  } = useAxios<DeviceLogsResponse>(API_ENDPOINTS.users.DEVICE_LOGS, 'POST');

  useEffect(() => {
    const fetchData = async () => {
      try {
        await DeviceLogsRequestData({
          startDate: startDateC,
          endDate: endDateC,
          fleetId: user.customer_id,
        });
      } catch (error) {
        console.error('Failed to fetch data:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
    // DeviceLogsRequestData({
    //   startDate: startDateC,
    //   endDate: endDateC,
    //   fleetId: user.customer_id,
    // });
  }, []);

  // Filtered data based on search query
  const filteredData = useMemo(() => {
    return data.filter(
      (DeviceLogs) =>
        DeviceLogs.logFileName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        DeviceLogs.deviceId.toLowerCase().includes(searchQuery.toLowerCase()) ||
        DeviceLogs.customerCrn.toLowerCase().includes(searchQuery.toLowerCase()),
    );
  }, [searchQuery]);

  const handleOpenMenu = (event: React.MouseEvent<HTMLSpanElement>, tripId: string) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // Update pagination keys if the API response contains lastEvaluatedKey
  useEffect(() => {
    if (DeviceLogsData?.data?.lastEvaluatedKey) {
      if (!paginatedArr.current.includes(DeviceLogsData.data?.lastEvaluatedKey)) {
        paginatedArr.current.push(DeviceLogsData.data?.lastEvaluatedKey);
      }
    }
  }, [DeviceLogsData]);

  const totalPages = DeviceLogsData?.data?.lastEvaluatedKey
    ? paginatedArr.current.length + 1
    : paginatedArr.current.length;

  const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {
    if (page > currentPage && !DeviceLogsData?.data?.lastEvaluatedKey) return;
    setCurrentPage(page);

    DeviceLogsRequestData({
      startDate: startDate || startDateC,
      endDate: endDate || endDateC,
      fleetId: user.customer_id,
      lastEvaluatedKey: page === 1 ? null : paginatedArr.current[page - 1],
    });
  };

  useEffect(() => {
    if (startDate && endDate) {
      setCurrentPage(1);
      paginatedArr.current = [null];

      DeviceLogsRequestData({
        startDate,
        endDate,
        fleetId: user.customer_id,
        lastEvaluatedKey: null,
      });
    }
  }, [startDate, endDate, selectedDuration]);

  const processedData = useMemo(() => {
    if (!DeviceLogsData?.data?.deviceLogsList) return [];
    return (DeviceLogsData as DeviceLogsResponse)?.data?.deviceLogsList?.map((report) => ({
      ...report,
      totalEventsCount: report.customerCrn ?? 0,
    }));
  }, [DeviceLogsData]);

  // Handle select all rows
  const handleSelectAllRows = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    const newSelectedRows: Record<string, boolean> = {};

    if (isChecked) {
      processedData.forEach((row) => {
        newSelectedRows[`${row.logFileName}_${row.deviceId}`] = true;
      });
    }

    setSelectedRows(newSelectedRows);
  };

  // Handle individual row selection
  const handleRowSelection =
    (fileName: string, deviceId: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const isChecked = event.target.checked;

      setSelectedRows((prev) => ({
        ...prev,
        [`${fileName}_${deviceId}`]: isChecked,
      }));
    };

  // Check if all rows are selected
  const allRowsSelected = useMemo(() => {
    return (
      Object.keys(selectedRows).length === processedData.length &&
      Object.keys(selectedRows).every((key) => selectedRows[key])
    );
  }, [selectedRows, processedData]);

  // Check if some rows are selected (but not all)
  const someRowsSelected = processedData.some((row) => selectedRows[row.deviceId]) && !allRowsSelected;

  const allColumns: MRT_ColumnDef<DeviceLogs>[] = useMemo(
    () => [
      {
        accessorKey: 'deviceId',
        header: 'Device ID',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 150,
        muiTableBodyCellProps: { sx: { padding: '8px' } },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'logFileName',
        header: 'File Name',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 150,
        muiTableBodyCellProps: { sx: { padding: '8px' } },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'fileStatus',
        header: 'File Status',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 150,
        muiTableBodyCellProps: { sx: { padding: '8px' } },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          let statusText = '';
          let isLink = false;
          let isDownload = false;

          if (value === 0) {
            statusText = 'Upload';
            isLink = true;
          } else if (value === 1) {
            statusText = 'Download';
            isLink = true;
            isDownload = true;
          } else {
            statusText = 'Unknown';
          }

          const handleDownloadClick = async (rowData: DeviceLogs) => {
            try {
              const payload = [
                {
                  customerId: rowData.customerCrn,
                  deviceId: rowData.deviceId,
                  file: rowData.logFileName,
                  fileStatus: rowData.fileStatus,
                },
              ];

              const response = await fetchDownloadDeviceLogsData(payload);

              if (response?.data?.[0]) {
                const downloadUrl = response.data[0];

                const fileResponse = await fetch(downloadUrl);

                if (!fileResponse.ok) {
                  throw new Error(`HTTP error! status: ${fileResponse.status}`);
                }

                const blob = await fileResponse.blob();

                const blobUrl = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = blobUrl;

                let filename = rowData.logFileName || 'device_log';
                if (!filename.toLowerCase().endsWith('.txt')) {
                  filename += '.txt';
                }
                link.download = filename;

                document.body.appendChild(link);

                link.click();

                setTimeout(() => {
                  document.body.removeChild(link);
                  window.URL.revokeObjectURL(blobUrl);
                }, 100);
              } else {
                setAlertMessage('No download URL received');
                setAlertType('error');
                setAlertOpen(true);
              }
            } catch (error) {
              console.error('Download error:', error);
              setAlertMessage('Failed to download file');
              setAlertType('error');
              setAlertOpen(true);
            }
          };

          return (
            <Typography variant="body2" fontWeight={400} noWrap>
              {isLink ? (
                <Box
                  sx={{
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                  }}
                >
                  <Button
                    sx={{
                      padding: 0,
                      minWidth: 0,
                      textTransform: 'none',
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (isDownload) {
                        handleDownloadClick(cell.row.original);
                      } else {
                        // console.log(statusText, 'clicked for row:', cell.row.original);
                      }
                    }}
                  >
                    {statusText}
                  </Button>
                </Box>
              ) : (
                statusText
              )}
            </Typography>
          );
        },
      },
      {
        accessorKey: 'fileDate',
        header: 'File Date',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 150,
        muiTableBodyCellProps: {
          sx: { padding: '8px' },
        },
        Cell: ({ cell }) => {
          const dateTimeString = cell.getValue<string>();
          const [year, month, day] = dateTimeString.split('-').slice(0, 3);

          const formattedDate = new Date(`${year}-${month}-${day}`);

          const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          };
          const formattedDateString = formattedDate.toLocaleDateString('en-GB', options);

          return (
            <Typography variant="body2" fontWeight={400} noWrap>
              {formattedDateString}
            </Typography>
          );
        },
      },
      {
        accessorKey: 'customerCrn',
        header: 'Customer Crn',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 150,
        muiTableBodyCellProps: { sx: { padding: '8px' } },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'actions',
        header: 'Select All',
        Header: ({ table }) => {
          return (
            <Box display="flex" alignItems="center">
              <Checkbox
                checked={allRowsSelected}
                indeterminate={someRowsSelected}
                onChange={handleSelectAllRows}
              />
              <Typography variant="body2" fontWeight={700}>
                Select All
              </Typography>
            </Box>
          );
        },
        enableColumnActions: false,
        size: 150,
        muiTableBodyCellProps: {
          sx: {
            padding: '8px',
            display: 'flex',
            justifyContent: 'flex-end',
          },
        },
        Cell: ({ row }) => (
          <Checkbox
            checked={!!selectedRows[`${row.original.logFileName}_${row.original.deviceId}`]}
            onChange={handleRowSelection(row.original.logFileName, row.original.deviceId)}
            onClick={(e) => e.stopPropagation()}
          />
        ),
      },
    ],
    [isSmallScreen, processedData, selectedRows],
  );

  const columns: MRT_ColumnDef<DeviceLogs>[] = useMemo(() => {
    return allColumns.filter((column) => {
      const key = column.accessorKey as keyof ColumnObjType;
      return columnObj[key]?.status;
    });
  }, [allColumns, columnObj]);

  // Table options
  const tableOptions: MRT_TableOptions<DeviceLogs> = {
    columns,
    data: processedData,
    enablePagination: false,
    enableColumnFilters: false,
    enableSorting: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableFullScreenToggle: false,
    enableColumnResizing: false,
    enableToolbarInternalActions: false,
    initialState: {
      columnPinning: {
        left: ['deviceId', 'date_time', 'vehicle'],
        right: [],
      },
    },
    muiTableBodyProps: {
      sx: {
        padding: 0,
        margin: 0,
      },
    },
    muiTableBodyRowProps: ({ row }) => ({
      onClick: () => {
        setSelectedRows((prev) => ({
          ...prev,
          [row.original.deviceId]: !prev[row.original.deviceId],
        }));
      },
      sx: {
        cursor: 'pointer',
        backgroundColor: selectedRows[row.original.deviceId] ? 'rgba(0, 0, 0, 0.04)' : 'inherit',
      },
    }),
  };

  // Initialize the table
  const table = useMaterialReactTable(tableOptions);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState<CompanyData | null>(null);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [isApplyDisabled, setIsApplyDisabled] = useState(true);
  const handelCompanyFilter = () => {
    setIsFilterModalOpen(!isFilterModalOpen);
  };
  interface CompanyData {
    id: string;
    name: string;
    description: string;
    type: string;
    crn: string;
    address: {
      fullAddress: string;
      city: string;
      state: string;
      pincode: number;
      country: string;
    };
    contacts: {
      telephoneNo: string;
      mobileNo: string;
      email: string;
    };
    url: string;
    status: number;
    deviceTypes: string[] | null;
  }

  const {
    data: companyList,
    error: companyListError,
    errorStatus: companyListErrorStatus,
    loading: companyListLoading,
    fetchData: fetchCompanyListData,
  } = useAxios<any>(`${API_ENDPOINTS.users.COMPANY_LIST}`, 'GET');

  const {
    data: companyListByCrn,
    error: companyListByCrnError,
    errorStatus: companyListByCrnErrorStatus,
    loading: companyListByCrnLoading,
    fetchData: fetchCompanyListByCrnData,
  } = useAxios<any>(`${API_ENDPOINTS.users.CUSTOMER_LIST_CRN}`, 'POST');

  const {
    data: companyListByCrnDevices,
    error: companyListByCrnDevicesError,
    errorStatus: companyListByCrnDevicesErrorStatus,
    loading: companyListByCrnDevicesLoading,
    fetchData: fetchCompanyListByCrnDevicesData,
  } = useAxios<any>(`${API_ENDPOINTS.users.CUSTOMER_LIST_DEVICES}`, 'POST');

  const {
    data: deviceLogRequest,
    error: deviceLogRequestError,
    errorStatus: deviceLogRequestErrorStatus,
    loading: deviceLogRequestLoading,
    fetchData: fetchDeviceLogRequestData,
  } = useApiError<any>(`${API_ENDPOINTS.users.DEVICE_LOG_REQUEST}`, 'POST');

  const {
    data: deviceLogSave,
    error: deviceLogSaveError,
    errorStatus: deviceLogSaveErrorStatus,
    loading: deviceLogSaveLoading,
    fetchData: fetchDeviceLogSaveData,
  } = useApiError<any>(`${API_ENDPOINTS.users.DEVICE_LOG_SAVE}`, 'POST');

  useEffect(() => {
    fetchCompanyListData();
  }, []);

  const isForbidden = DeviceLogsErrorStatus === '403' || deviceLogSaveErrorStatus === '403';

  useEffect(() => {
    if (selectedCompany) {
      fetchCompanyListByCrnData({
        userId: selectedCompany.id,
        userCrn: selectedCompany.crn,
      });
    }
  }, [selectedCompany]);

  useEffect(() => {
    if (selectedUser) {
      fetchCompanyListByCrnDevicesData({
        fleetId: selectedUser.id,
      });
    }
  }, [selectedUser]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchDeviceLogRequestData({});
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const companyData = useMemo(() => {
    if (!companyList?.data) return [];

    return (companyList.data as CompanyData[]).map((company) => {
      return {
        ...company,
      };
    });
  }, [companyList]);

  const [firstSelectValue, setFirstSelectValue] = useState('');
  const [secondSelectValue, setSecondSelectValue] = useState('');
  const [thirdSelectValue, setThirdSelectValue] = useState('');
  const [logFileDate, setLogFileDate] = useState<string | null>(null);

  const isAnyRowSelected = useMemo(() => {
    return Object.values(selectedRows).some((value) => value);
  }, [selectedRows]);

  return (
    <>
      <AlertToast
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
      {isLoading ? (
        <></>
      ) : isForbidden ? (
        <NotAuthorized />
      ) : (
        <div className="flex flex-col gap-4 w-full">
          {/* Search Input */}
          <div className="w-full">
            <button className="text-blue-600 font-medium flex items-center" onClick={() => navigate(-1)}>
              <ArrowBack className="mr-1" /> Back
            </button>
          </div>
          <div className=" w-full flex lg:flex-row md:flex-row flex-col justify-between gap-4 xs:flex-col items-start">
            <div className="max-w-max">
              <div className="dashboard-header-left">
                <div className="flex flex-col items-start">
                  <Typography variant="h4" fontSize="24px" fontWeight={600} lineHeight="36px">
                    Device Logs
                  </Typography>
                  <Typography variant="subtitle1" fontSize={16} fontWeight={400} lineHeight="24px">
                    Select devices to perform any action
                  </Typography>
                </div>
              </div>
            </div>
            <div className="flex gap-4 flex-wrap">
              <CustomIconButton
                icon={<img src={add} alt="add" width={16} height={16} />}
                text="Add New"
                background="transparent"
                outline={true}
                onClick={handelCompanyFilter}
              />
              {isFilterModalOpen && (
                <>
                  <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[999]"></div>
                  <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 z-[1000] rounded-2xl shadow-xl flex flex-col w-full max-w-[480px] mx-auto border border-gray-100">
                    <Typography variant="h6" fontSize={28} fontWeight={600} className="text-left">
                      Add New Device Log
                    </Typography>
                    <Typography variant="body2" fontSize={14} fontWeight={400} className="text-left">
                      Add new device log by company, customer.
                    </Typography>
                    <div className="flex flex-col gap-4 mt-8">
                      {/* Company Dropdown */}
                      <CustomDropDownInput
                        label="Company"
                        options={companyData.map((company) => ({
                          value: company.name,
                          label: company.name,
                        }))}
                        value={firstSelectValue}
                        onChange={(e) => {
                          const selected = companyData.find((company) => company.name === e);
                          setFirstSelectValue(e);
                          setSelectedCompany(selected || null);
                          setSecondSelectValue('');
                        }}
                        placeholder="Select Company"
                        showDropdownArrow={true}
                        isMandatory
                      />

                      {/* Customer Dropdown */}
                      <CustomDropDownInput
                        label="Customer"
                        options={
                          companyListByCrn?.data?.map((user: any) => ({
                            value: user.fullName,
                            label: user.fullName,
                          })) || []
                        }
                        value={secondSelectValue}
                        onChange={(e) => {
                          const selected = companyListByCrn?.data?.find((user: any) => user.fullName === e);
                          setSecondSelectValue(e);
                          setSelectedUser(selected || null);
                        }}
                        placeholder={selectedCompany ? 'Select User' : 'First Select Company'}
                        showDropdownArrow={true}
                        isDisabled={!selectedCompany}
                        isMandatory
                      />

                      {/* Device Dropdown */}
                      <CustomDropDownInput
                        label="Device"
                        options={
                          companyListByCrnDevices?.data?.map((device: any) => ({
                            value: device.deviceId,
                            label: device.deviceId,
                          })) || []
                        }
                        value={thirdSelectValue}
                        onChange={(e) => {
                          const selected = companyListByCrnDevices?.data?.find(
                            (device: any) => device.deviceId === e,
                          );
                          setThirdSelectValue(e);
                          setIsApplyDisabled(!e);
                        }}
                        placeholder={selectedCompany ? 'Select Device' : 'First Select User'}
                        showDropdownArrow={true}
                        isDisabled={!selectedCompany}
                        isMandatory
                      />

                      {/* Log File Date */}
                      <DateFieldCalendar
                        label="Log File Date"
                        name="logFileDate"
                        value={logFileDate}
                        onChange={setLogFileDate}
                        isDisabled={!selectedCompany}
                        format="YYYY-MM-DD"
                        isMandatory={true}
                      />
                    </div>
                    <div className="flex justify-between gap-4 mt-8">
                      <CustomIconButton
                        text="Cancel"
                        background="transparent"
                        outline={true}
                        onClick={() => {
                          setIsFilterModalOpen(false);
                          setFirstSelectValue('');
                          setSecondSelectValue('');
                          setThirdSelectValue('');
                          setLogFileDate(null);
                          setSelectedCompany(null);
                          setSelectedUser(null);
                        }}
                      />
                      <CustomIconButton
                        text="Apply"
                        isDisabled={isApplyDisabled}
                        outline={false}
                        onClick={async () => {
                          setIsSendingEmail(true);
                          if (selectedUser && thirdSelectValue && logFileDate) {
                            const data = {
                              fleetId: selectedUser.id,
                              deviceId: thirdSelectValue,
                              logFileDate: logFileDate,
                            };
                            try {
                              const response = await fetchDeviceLogSaveData(data);

                              if (response.status === 201 || response.status === 200) {
                                setAlertMessage(response?.message || 'Operation successful');
                                setAlertType('success');
                              } else {
                                setAlertMessage(
                                  response?.error ||
                                    response?.message ||
                                    response.message ||
                                    'Operation failed',
                                );
                                setAlertType('error');
                              }

                              setAlertOpen(true);
                              setCurrentPage(1);
                              paginatedArr.current = [null];
                              setIsFilterModalOpen(false);
                              setFirstSelectValue('');
                              setSecondSelectValue('');
                              setThirdSelectValue('');
                              setLogFileDate(null);
                              setSelectedCompany(null);
                              setSelectedUser(null);

                              await DeviceLogsRequestData({
                                fleetId: user.customer_id,
                              });
                            } catch (error) {
                              console.error('Error:', error);
                              setAlertMessage(
                                (error as any)?.response?.message ||
                                  (error as Error)?.message ||
                                  'An unknown error occurred',
                              );
                              setAlertType('error');
                              setAlertOpen(true);
                            } finally {
                              setIsSendingEmail(false);
                            }
                          }
                        }}
                      />
                    </div>
                  </div>
                </>
              )}
              <CustomIconButton
                text="Delete certification"
                background="transparent"
                outline={false}
                onClick={async () => {
                  if (!isAnyRowSelected) {
                    setAlertMessage('Please select at least one device');
                    setAlertType('error');
                    setAlertOpen(true);
                    return;
                  }

                  try {
                    // Prepare payload from selected rows - group by deviceId
                    const deviceMap = new Map();

                    processedData
                      .filter((row) => selectedRows[`${row.logFileName}_${row.deviceId}`])
                      .forEach((row) => {
                        // Use deviceId as the key - this ensures each device only appears once
                        if (!deviceMap.has(row.deviceId)) {
                          deviceMap.set(row.deviceId, {
                            customerId: row.customerCrn,
                            deviceId: row.deviceId,
                          });
                        }
                      });

                    // Convert the Map values to an array
                    const payload = Array.from(deviceMap.values());

                    const response = await fetchDeleteCerificateDeviceLogsData(payload);

                    if (response) {
                      setAlertMessage('Certificates deleted successfully');
                      setAlertType('success');
                      setAlertOpen(true);

                      DeviceLogsRequestData({
                        startDate: startDateC,
                        endDate: endDateC,
                        fleetId: user.customer_id,
                      });

                      setSelectedRows({});
                    }
                  } catch (error) {
                    console.error('Delete certification error:', error);
                    setAlertMessage('Failed to delete certificates');
                    setAlertType('error');
                    setAlertOpen(true);
                  }
                }}
                isDisabled={!isAnyRowSelected}
              />
              <CustomIconButton
                text="Delete"
                background="transparent"
                variant="contained"
                onClick={() => {
                  if (!isAnyRowSelected) {
                    setAlertMessage('Please select at least one device');
                    setAlertType('error');
                    setAlertOpen(true);
                    return;
                  }
                  setIsBulkDeleteModalOpen(true);
                }}
                isDisabled={!isAnyRowSelected}
              />
              <CustomIconButton
                icon={<img src={downloadWhiteIcon} alt="download" width={16} height={16} />}
                text="Download"
                variant="contained"
                onClick={async () => {
                  const selectedDevices = Object.keys(selectedRows).filter((key) => selectedRows[key]);
                  if (selectedDevices.length === 0) {
                    setAlertMessage('Please select at least one device');
                    setAlertType('error');
                    setAlertOpen(true);
                    return;
                  }

                  try {
                    // Process each selected file individually
                    const downloadPromises = processedData
                      .filter((row) => selectedRows[`${row.logFileName}_${row.deviceId}`])
                      .map(async (row) => {
                        const payload = [
                          {
                            customerId: row.customerCrn,
                            deviceId: row.deviceId,
                            file: row.logFileName,
                            fileStatus: row.fileStatus,
                          },
                        ];

                        const response = await fetchDownloadDeviceLogsData(payload);

                        if (response?.data?.[0]) {
                          const downloadUrl = response.data[0];
                          const fileResponse = await fetch(downloadUrl);

                          if (!fileResponse.ok) {
                            throw new Error(`HTTP error! status: ${fileResponse.status}`);
                          }

                          const blob = await fileResponse.blob();
                          const blobUrl = window.URL.createObjectURL(blob);
                          const link = document.createElement('a');
                          link.href = blobUrl;

                          // Ensure filename ends with .txt
                          let filename = row.logFileName || 'device_log';
                          if (!filename.toLowerCase().endsWith('.txt')) {
                            filename += '.txt';
                          }
                          link.download = filename;

                          document.body.appendChild(link);
                          link.click();

                          // Clean up
                          setTimeout(() => {
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(blobUrl);
                          }, 100);

                          return true;
                        }
                        return false;
                      });

                    // Wait for all downloads to initiate
                    const results = await Promise.all(downloadPromises);
                    const successfulDownloads = results.filter(Boolean).length;

                    setSelectedRows({});

                    if (successfulDownloads > 0) {
                      setAlertMessage(`Initiated download for ${successfulDownloads} file(s)`);
                      setAlertType('success');
                      setAlertOpen(true);
                    } else {
                      setAlertMessage('No files were downloaded');
                      setAlertType('warning');
                      setAlertOpen(true);
                    }
                  } catch (error) {
                    console.error('Download error:', error);
                    setAlertMessage('Failed to download some files');
                    setAlertType('error');
                    setAlertOpen(true);
                  }
                }}
                isDisabled={!isAnyRowSelected}
              />
            </div>
          </div>
          {/* Data Table */}
          <MaterialReactTable table={table} />

          {/* MUI Pagination */}
          <Box display="flex" justifyContent="center" mt={2}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              shape="rounded"
              color="primary"
              siblingCount={0}
              boundaryCount={0}
              renderItem={(item) => {
                if (item.type === 'page' && item.page !== null && item.page > currentPage) {
                  return null;
                }
                return <PaginationItem {...item} />;
              }}
            />
          </Box>

          <CustomConfirmationModal
            open={isBulkDeleteModalOpen}
            onCancel={() => setIsBulkDeleteModalOpen(false)}
            onConfirm={async () => {
              try {
                // Prepare payload from selected rows - group by deviceId
                const deviceMap = new Map();

                processedData
                  .filter((row) => selectedRows[`${row.logFileName}_${row.deviceId}`])
                  .forEach((row) => {
                    if (!deviceMap.has(row.deviceId)) {
                      deviceMap.set(row.deviceId, {
                        customerId: row.customerCrn,
                        deviceId: row.deviceId,
                        file: row.logFileName,
                      });
                    }
                  });

                const payload = Array.from(deviceMap.values());
                const response = await fetchDeleteDataDeviceLogsData(payload);

                if (response) {
                  setAlertMessage('Device(s) deleted successfully');
                  setAlertType('success');
                  setAlertOpen(true);

                  DeviceLogsRequestData({
                    startDate: startDateC,
                    endDate: endDateC,
                    fleetId: user.customer_id,
                  });

                  setSelectedRows({});
                }
              } catch (error) {
                console.error('Delete certification error:', error);
                setAlertMessage('Failed to delete Device(s)');
                setAlertType('error');
                setAlertOpen(true);
              } finally {
                setIsBulkDeleteModalOpen(false);
              }
            }}
            title="Confirm Delete"
            message="Are you sure you want to delete the selected device logs?"
            confirmButtonLabel="Delete"
            cancelButtonLabel="Cancel"
            confirmButtonColor="error"
            cancelButtonColor="primary"
          />
        </div>
      )}
    </>
  );
}
